export const useFeatureFlags = () => {
  const currentSite = inject("currentSite")

  const inAgeRestrictedLocation = inject("inAgeRestrictedLocation")
  const ageRestrictedSites = [
    "anal4k",
    "baeb",
    "bbcpie",
    "castingcouchx",
    "cum4k",
    "exotic4k",
    "facials4k",
    "fantasyhd",
    "gayroom",
    "girlcum",
    "holed",
    "lubed",
    "massagebait",
    "mom4k",
    "momcum",
    "myveryfirsttime",
    "nannyspy",
    "passionhd",
    "pornplus",
    "pornpros",
    "povd",
    "puremature",
    "showerbait",
    "spyfam",
    "strippers4k",
    "tiny4k",
    "wetvr",
  ]

  // Helper to normalize site names by removing hyphens/dashes
  const normalizeSiteName = (name) => name.replace(/-/g, "")

  const ageRestrictionFlag =
    inAgeRestrictedLocation &&
    ageRestrictedSites.includes(normalizeSiteName(currentSite.value.slug))

  return { ageRestrictionFlag }
}
